import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/variables.css";
import "./styles/themes/light.theme.css";
import "./styles/themes/dark.theme.css";
import "./styles/global.css";
import "./styles/utils.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProviderWrapper } from "./contexts/auth.context";
import { ToastProvider } from "./contexts/toast.context";
import { ThemeProvider } from "./contexts/theme.context";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Router>
        <ToastProvider>
          <AuthProviderWrapper>
            <App />
          </AuthProviderWrapper>
        </ToastProvider>
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);